<!-- Cobertura -->
<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>
  <!-- FILTROS -->
  <app-filters filtros [name]="'filtros.per' | translate" [array]="Periodos" [typeFilter]="Filters.PERIOD"
      (eventClick)="cambioPeriodo($event)">
  </app-filters>
   <!-- CONTENIDO -->
  <div contenido class="zonaContenido">
    <div class="zona1">
      <div class="tablaZona1 w3-white">
        <div class="headers w3-titulo-contenidomenuSC">
          <div class="w3-half">
            <span class="w3-margin-left-contenido">{{ 'financiero.coberturaRiesgos.titulo1' | translate}}</span>
            <span class="w3-margin-left-contenido">&bull;</span>
            <span class="w3-margin-left-filter w3-subtitulo">{{escrituraPer(subTitles)}}</span>
          </div>
          <div class="w3-rest w3-right">
            <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click"
              [ngStyle]="{'color':'gray'}" [matMenuTriggerFor]="menuTabla">
              more_vert
            </mat-icon>
            <mat-menu #menuTabla="matMenu">
              <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="exportarExcel()">
                <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
                <span>{{'menu.Exportar' | translate}}</span>
              </button>
            </mat-menu>
          </div>
        </div>
        <div class="w3-row w3-scroll " style="width: 100%; height: 90%;">
          @if(dataTabla.length !== 0){
            <table class="w3-table borderInf">
              <thead>
                <tr class="w3-center w3-table-title">
                  <th class="w3-border-right-balance stikyColum">{{'financiero.coberturaRiesgos.titulo1Tabla'|translate}}</th>
                  <th class="w3-border-right-balance stikyColum">{{'financiero.coberturaRiesgos.titulo2Tabla'|translate}}</th>
                  <th class="w3-border-right-balance stikyColum">{{'financiero.coberturaRiesgos.titulo3Tabla'|translate}}</th>
                  <th class="w3-border-right-balance stikyColum">{{'financiero.coberturaRiesgos.titulo4Tabla'|translate}}</th>
                </tr>
              </thead>
              <tbody>
                @for (dat of dataTabla; track dat; let i = $index) {
                  <tr class="w3-table-trtd">
                    @if (i<=ingresos-1) { 
                      <td class="alinLeft borderAllLow" [ngClass]="{'estiloNivel1': dat.nivel === 1,
                        'estiloNivel2': dat.nivel === 2,'estiloNivel3': dat.nivel === 3,'borderInf':i===dataTabla.length-2}">
                        <span>{{dat.concepto}}</span>
                      </td>
                    }
                    @if (i>ingresos-1) {
                      <td class="w3-center borderAllLow" [ngClass]="{'estiloNivel1': dat.nivel === 1,
                        'estiloNivel2': dat.nivel === 2,'estiloNivel3': dat.nivel === 3,'borderInf':i===dataTabla.length-2}">
                        <span>{{dat.anio}}</span>
                      </td>
                    }
                    <td class="alinRight borderAllLow" [ngClass]="{'estiloNivel1': dat.nivel === 1,
                      'estiloNivel2': dat.nivel === 2,'estiloNivel3': dat.nivel === 3, 'borderInf':i===dataTabla.length-2}">
                      @if(dat.monto !== ""){<span style="margin-right: 5%;">{{dat.monto | formaterNumber:0:miles:decimal}}</span>}
                    </td>
                    <td class="w3-center borderAllLow" [ngClass]="{'estiloNivel1': dat.nivel === 1,
                      'estiloNivel2': dat.nivel === 2,'estiloNivel3': dat.nivel === 3}">
                      @if(dat.porcen !== ""){<span>{{dat.porcen | formaterNumber:1:miles:decimal}} %</span>}
                    </td>
                    <td class="alinRight borderAllLow" [ngClass]="{'estiloNivel1': dat.nivel === 1,
                      'estiloNivel2': dat.nivel === 2,'estiloNivel3': dat.nivel === 3}">
                      @if(dat.tot !== ""){<span style="margin-right: 5%;">{{dat.tot | formaterNumber:0:miles:decimal}}</span>}
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          }@else{ <app-skeleton-table [filas]="8" [columnas]="4"/> }          
        </div>
      </div>
      <div class="graficaZona1">
        <div style="height: 50%;">
          <div class="w3-titulo-contenidomenuSC">
            <span class="w3-margin-left-contenido">{{'financiero.coberturaRiesgos.tituloTarjeta1'|translate}}</span>
          </div>
          <div style="width: 98%; height: 77%;">
            <app-tarjetas [header]="salcoberturaC.nombre"
              [value]="salcoberturaC.dato" [footer]="escrituraPer(subTitles)" [icon]="'percent'"
              [color]="'#1976d2'" [iconFirst]="false">
            </app-tarjetas>
          </div>
        </div>
        <div style="height: 50%;">
          <div class="w3-titulo-contenidomenuSC" style="margin-top: 0.5vh;">
            <span class="w3-margin-left-contenido">{{'financiero.coberturaRiesgos.tituloTarjeta2'|translate}}</span>
          </div>
          <div style="width: 98%; height: 77%;">
            <app-tarjetas [header]="salcoberturaS.nombre"
              [value]="salcoberturaS.dato" [footer]="escrituraPer(subTitles)" [icon]="'percent'"
              [color]="'#1976d2'" [iconFirst]="false">
            </app-tarjetas>
          </div>
        </div>
      </div>
    </div>
    <div class="zona2" id="conteGrafica">
      <div class="headers w3-titulo-contenidomenuSC">
        <div class="w3-half">
          <span class="w3-margin-left-contenido">{{ 'financiero.coberturaRiesgos.titulo2' | translate}}</span>
          <span class="w3-margin-left-contenido">&bull;</span>
          <span class="w3-margin-left-filter w3-subtitulo">{{escrituraPer(subTitles2)}}</span>
        </div>
        <div class="w3-rest w3-right">
          <mat-icon class="w3-button w3-dropdown-click iconoMen" [ngStyle]="{'color':'gray'}"
            (click)="showLabelsGraf = !showLabelsGraf" matTooltip="{{'tooltips.tooltipIcono7'|translate}}">
            {{ showLabelsGraf ? 'label_off' : 'label' }}
          </mat-icon>
          <mat-icon class="w3-button w3-dropdown-click iconoMen" [ngStyle]="{'color':'gray'}"
            (click)="openModal('graf1')"
            matTooltip="{{'financiero.evaluacionIndicador.tooltipIcono2'|translate}}">
            zoom_out_map
          </mat-icon>
          <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
            [matMenuTriggerFor]="menuGrafPrincipal">
            more_vert
          </mat-icon>
          <mat-menu #menuGrafPrincipal="matMenu">
            <button class="mat-menu-item" mat-menu-item class="w3-caja-menu"
              [matMenuTriggerFor]="menuTiposGraf">
              <mat-icon [ngStyle]="{'color':'gray'}">assessment</mat-icon>
              <span>{{'financiero.coberturaRiesgos.tooltipIcono1'|translate}}</span>
            </button>
            <button class="mat-menu-item" mat-menu-item class="w3-caja-menu"
              (click)="exportarGraf(1,'financiero.coberturaRiesgos.titulo2')">
              <mat-icon [ngStyle]="{'color':'gray'}">image</mat-icon>
              <span>{{'menu.Exportar' | translate}}</span>
            </button>
          </mat-menu>
          <mat-menu #menuTiposGraf="matMenu">
            <button mat-menu-item [ngClass]="{'w3-disabled': tipo === 'bar'}" [disabled]="tipo == 'bar'"
              (click)="optionsGraf('bar')">
              <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
              <span>{{'financiero.coberturaRiesgos.tooltipIcono3'|translate}}</span>
            </button>
            <button mat-menu-item [ngClass]="{'w3-disabled': tipo === 'line'}" [disabled]="tipo == 'line'"
              (click)="optionsGraf('line')">
              <mat-icon [ngStyle]="{'color':'gray'}">show_chart</mat-icon>
              <span>{{'financiero.coberturaRiesgos.tooltipIcono4'|translate}}</span>
            </button>
            <button mat-menu-item [ngClass]="{'w3-disabled': tipo === 'area'}" [disabled]="tipo == 'area'"
              (click)="optionsGraf('area')">
              <mat-icon [ngStyle]="{'color':'gray'}">area_chart</mat-icon>
              <span>{{'financiero.coberturaRiesgos.tooltipIcono5'|translate}}</span>
            </button>
          </mat-menu>
        </div>
      </div>
      <div class="w3-row" style="height: 93%; background-color: white;">
        <div class="graficaPos">
          @if(etiquetasGraf.length !== 0){
            <app-graficador
              [etiquetas]="showLabelsGraf"
              [data]="datosGraficador"
              [labels]="etiquetasGraf"
              [type]="tipoGrafActual"
              [axisX]="'Períodos'"
              [axisY]="['Cobertura (%)']"
              [zona]="1"
              [colors]="colorScheme"
              [formatEtiquetas]="true"
              [animations]="true"
              [speedAnimations]="500"
              [legend]="{enabled: true, position: 'bottom'}">
            </app-graficador>
          }@else { <app-skeleton-grafica/>}                    
        </div>
      </div>
    </div>  
  </div>
</app-esqueleto-tableros>

<app-modal [isOpen]="modalOpen" (close)="modalOpen = !modalOpen">
  <div modal-header style="width: 70vw;">
    <div class="w3-row">
      <div class="w3-half">
        <div class="w3-row w3-white w3-header-cuadrante padreizquierda"
          style="height: 6vh; margin-top: 10px; margin-left: 20px;">
          <div class="w3-noventa2 w3-titulo-contenidomenu bottom hijoizquierdaTitle">
            <div class="hijoizquierdaTitle">
              <div class="w3-row">
                <!--Titulo-->
                <div class="w3-noventa w3-titulo-contenidomenu padreizquierda">
                  <div class="hijoizquierdaTitle">
                    @if (graf1) {<span class="w3-margin-left-contenido">{{'financiero.coberturaRiesgos.titulo2' | translate }}</span>}
                    <span class="w3-margin-left-contenido">&bull;</span>
                    <span class="w3-margin-left-filter w3-subtitulo">{{escrituraPer(subTitles2)}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="w3-rest w3-right" style="height: 6vh; margin-top: 10px;">
        <div class="w3-row" style="height: 3vh; transform: translate(0, 40%);">
          <mat-icon fontSet="material-icons-outlined" class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
            (click)="showLabelsGraf = !showLabelsGraf" matTooltip="{{'tooltips.tooltipIcono7'|translate}}">
            {{ showLabelsGraf ? 'label_off' : 'label' }}
          </mat-icon>
          <mat-icon class="w3-button w3-dropdown-click" style="margin-right: 18px;"[ngStyle]="{'color':'gray'}"
            (click)="exportarGraf(1,'financiero.coberturaRiesgos.titulo2')" matTooltip="{{'menu.exportar' | translate}}">
            image
          </mat-icon>
        </div>
      </div>
    </div>
  </div>
  <div modal-body>
    @if (graf1) {
      <div class="w3-row contentGraf">
        <app-graficador
          [etiquetas]="showLabelsGraf"
          [data]="datosGraficador"
          [labels]="etiquetasGraf"
          [type]="tipoGrafActual"
          [axisX]="'Períodos'"
          [axisY]="['Cobertura (%)']"
          [zona]="6"
          [colors]="colorScheme"
          [formatEtiquetas]="true"
          [legend]="{enabled: false, position: 'right'}"
          [animations]="true"
          [speedAnimations]="500"
          [legend]="{enabled: true, position: 'bottom'}"
        ></app-graficador>
      </div>
    }
  </div>
</app-modal>